import { createFileRoute, Link } from "@tanstack/react-router";
import { loadIntegrationsByCategory } from "~/utils/content-fns";
import { seo, seoLinks } from "~/utils/seo";

export const Route = createFileRoute("/integrations/$category/")({
  loader: ({ params }) =>
    loadIntegrationsByCategory({ data: { category: params.category } }),
  head: ({ loaderData, params }) => {
    const label = params.category
      .split("-")
      .map((w) => w[0].toUpperCase() + w.slice(1))
      .join(" ");
    return {
      meta: seo({
        title: `${label} Integrations`,
        description: `C1 integrations for ${label}.`,
        url: `/integrations/${params.category}/`,
      }),
      links: seoLinks({ url: `/integrations/${params.category}/` }),
    };
  },
  component: IntegrationCategory,
});

function IntegrationCategory() {
  const integrations = Route.useLoaderData();
  const { category } = Route.useParams();
  const label = category
    .split("-")
    .map((w) => w[0].toUpperCase() + w.slice(1))
    .join(" ");

  return (
    <div className="mx-auto max-w-screen-md px-4 py-8 md:px-8 md:py-16">
      <div className="my-16">
        <div className="my-4 text-xs font-semibold uppercase tracking-widest text-gray-3">
          <p>Category</p>
          <span className="mt-4 block w-3 border-b-2 border-gray-4" />
        </div>
        <h1 className="text-4xl">{label}</h1>
      </div>
      <ul className="space-y-4">
        {integrations.map(
          (i: {
            slug: string;
            title: string;
            _category?: string;
            image?: string;
          }) => (
            <li key={i.slug} className="flex items-center gap-3">
              {i.image && (
                <img
                  src={i.image}
                  alt=""
                  className="h-8 w-8 object-contain"
                  loading="lazy"
                />
              )}
              <h3 className="text-lg leading-tight">
                <Link
                  to="/integrations/$category/$slug"
                  params={{ category, slug: i.slug }}
                  className="hover:text-teal-dark"
                >
                  {i.title}
                </Link>
              </h3>
            </li>
          ),
        )}
      </ul>
      <div className="mt-12">
        <Link
          to="/integrations"
          className="inline-flex items-center gap-2 border-b border-gray-40 pb-px text-gray-60 transition-all hover:border-gray-80 hover:text-gray-80"
        >
          ← All integrations
        </Link>
      </div>
    </div>
  );
}
